module.exports = __webpack_public_path__ + "static/agile.b1d35cb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/agile.png
// module id = 782
// module chunks = 34885888655430